import React from 'react';

const UploadDocumentsIcon: React.FC = () => {
  return (
    <svg
      width="121"
      height="110"
      viewBox="0 0 121 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4949 32.1499C10.0345 27.5377 12.5895 22.6149 17.2016 21.1545L50.6058 10.5771L83.592 27.6972L99.458 77.8035C100.918 82.4156 98.3635 87.3384 93.7513 88.7989L43.6451 104.665C39.0329 106.125 34.1101 103.57 32.6497 98.9582L11.4949 32.1499Z"
        fill="#A7A4A9"
      />
      <path
        d="M50.6064 10.5762L83.5926 27.6963L66.8905 32.985C62.2784 34.4454 57.3556 31.8904 55.8951 27.2783L50.6064 10.5762Z"
        fill="#E9EAEB"
      />
      <g clipPath="url(#clip0_1679_5815)">
        <path
          d="M44.2031 67.7348L72.0399 58.9203M41.9995 60.7756L48.9587 58.572M62.8771 54.1647L69.8363 51.9611M46.4068 74.694L53.366 72.4904M67.2844 68.0832L74.2436 65.8795M55.5696 79.4496L46.7551 51.6128M69.488 75.0424L60.6735 47.2055M55.2912 79.5377L69.7664 74.9542C72.1049 74.2137 73.2741 73.8435 74.0232 73.1055C74.6821 72.4564 75.1186 71.6154 75.2702 70.703C75.4424 69.6657 75.0722 68.4964 74.3317 66.1579L69.7482 51.6828C69.0077 49.3442 68.6375 48.175 67.8995 47.4259C67.2504 46.767 66.4094 46.3305 65.4969 46.179C64.4596 46.0067 63.2904 46.3769 60.9519 47.1174L46.4767 51.7009C44.1382 52.4414 42.969 52.8117 42.2199 53.5496C41.561 54.1987 41.1245 55.0397 40.9729 55.9522C40.8006 56.9895 41.1709 58.1587 41.9114 60.4972L46.4949 74.9724C47.2354 77.3109 47.6056 78.4801 48.3436 79.2292C48.9927 79.8881 49.8337 80.3247 50.7461 80.4762C51.7834 80.6485 52.9527 80.2782 55.2912 79.5377Z"
          stroke="#414651"
          strokeWidth="3.28489"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <mask
        id="mask0_1679_5815"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="30"
        y="2"
        width="78"
        height="96"
      >
        <path
          d="M41.2447 10.4303C41.9768 5.64816 46.447 2.365 51.2291 3.09714L85.8644 8.39974L107.864 38.3532L99.91 90.3061C99.1778 95.0882 94.7076 98.3714 89.9255 97.6392L37.9726 89.6853C33.1905 88.9532 29.9073 84.483 30.6394 79.7008L41.2447 10.4303Z"
          fill="black"
        />
      </mask>
      <g mask="url(#mask0_1679_5815)">
        <path
          d="M41.2447 10.4303C41.9768 5.64816 46.447 2.365 51.2291 3.09714L85.8644 8.39974L107.864 38.3532L99.91 90.3061C99.1778 95.0882 94.7076 98.3714 89.9255 97.6392L37.9726 89.6853C33.1905 88.9532 29.9073 84.483 30.6394 79.7008L41.2447 10.4303Z"
          fill="#4E4852"
        />
      </g>
      <path
        d="M85.8643 8.40039L107.864 38.3538L90.5461 35.7025C85.764 34.9704 82.4808 30.5002 83.213 25.718L85.8643 8.40039Z"
        fill="#E9EAEB"
      />
      <g clipPath="url(#clip1_1679_5815)">
        <path
          d="M54.8209 56.8161L83.6836 61.235M55.9256 49.6004L63.1412 50.7052M77.5726 52.9146L84.7883 54.0193M53.7161 64.0318L60.9318 65.1365M75.3632 67.3459L82.5789 68.4506M59.8271 72.3522L64.246 43.4895M74.2585 74.5616L78.6773 45.6989M59.5385 72.308L74.5471 74.6058C76.9718 74.977 78.1841 75.1626 79.1825 74.8325C80.0607 74.5422 80.8244 73.9813 81.3642 73.2302C81.9779 72.3763 82.1635 71.164 82.5347 68.7393L84.8325 53.7307C85.2037 51.306 85.3893 50.0936 85.0592 49.0953C84.7689 48.2171 84.2079 47.4534 83.4569 46.9136C82.603 46.2999 81.3906 46.1143 78.9659 45.7431L63.9573 43.4453C61.5326 43.0741 60.3203 42.8885 59.3219 43.2186C58.4438 43.5089 57.68 44.0698 57.1402 44.8209C56.5266 45.6748 56.341 46.8871 55.9698 49.3118L53.672 64.3204C53.3007 66.7451 53.1151 67.9575 53.4452 68.9558C53.7356 69.834 54.2965 70.5977 55.0476 71.1375C55.9014 71.7512 57.1138 71.9368 59.5385 72.308Z"
          stroke="white"
          strokeOpacity="0.5"
          strokeWidth="3.28489"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1679_5815">
          <rect
            width="35.0388"
            height="35.0388"
            fill="white"
            transform="translate(36.1309 51.9141) rotate(-17.5703)"
          />
        </clipPath>
        <clipPath id="clip1_1679_5815">
          <rect
            width="35.0388"
            height="35.0388"
            fill="white"
            transform="translate(54.5859 39.0566) rotate(8.70431)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UploadDocumentsIcon;
